<template>
  <div>
    <div class="formBox">
      <Form
        label-position="right"
        :label-width="100"
        :model="formData"
        ref="form"
        :rules="ruleValidate"
      >
        <FormItem label="业务编码:" prop="bizNoPrefix">
          <Input placeholder="请输入业务编码" v-model="formData.bizNoPrefix" />
        </FormItem>
        <FormItem label="审批模版名称:" prop="tplName">
          <Input placeholder="请输入审批模版名称" v-model="formData.tplName" />
        </FormItem>
        <FormItem label="排序:" prop="sortNum">
          <Input number placeholder="请输入内容" v-model="formData.sortNum" />
        </FormItem>
        <FormItem label="模版组:" prop="tplGroupId">
          <Select v-model="formData.tplGroupId" placeholder="请选择模版组">
            <Option
              v-for="item in tempGroupOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="审批来源:" prop="applyFrom">
          <Select v-model="formData.applyFrom" placeholder="请选择审批来源">
            <Option
              v-for="item in applyFormOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="模版描述:" prop="note">
          <Input
            v-model="formData.note"
            placeholder="请输入模版描述,最多200字"
            type="textarea"
            maxlength="200"
            show-word-limit
          />
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import {
  getTplGroup,
  saveBaseInfo,
  editBaseInfo,
  getBaseInfoData,
  getMaxSortNum
} from '@/api/tempApproval';
import { tempGroupRuleValidate, applyFormOptions } from './modalConfig.js';
export default {
  name: 'TempGroupModal',
  props: {
    type: {
      type: String,
      default: 'create'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        bizNoPrefix: '',
        tplName: '',
        tplGroupId: '',
        applyFrom: 0,
        note: '',
        sortNum: ''
      },
      applyFormOptions,
      ruleValidate: tempGroupRuleValidate,
      tempGroupOptions: []
    };
  },
  methods: {
    submitBaseInfo(id) {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            const data = { ...this.formData };
            // 调用接口保存或编辑
            let method = saveBaseInfo;
            if (this.type == 'edit') {
              data.id = id;
              method = editBaseInfo;
            }
            method(data).then(res => {
              const { code, data } = res.data;
              if (code == 200) {
                resolve(data);
              }
            });
          }
        });
      });
    },
    async getTempGroupOptions() {
      const res = await getTplGroup();
      const { code, data } = res.data;
      if (code == 200) {
        const options = data.map(item => {
          const { id, name } = item;
          return {
            value: id,
            name
          };
        });
        this.tempGroupOptions = options;
      }
    },
    getDetail() {
      getBaseInfoData(this.id).then(res => {
        const { data, code } = res.data;
        if (code == 200) {
          this.formData = data;
        }
      });
    },
    async getSortNum() {
      const res = await getMaxSortNum();
      const { data, code } = res.data;
      if (code == 200) {
        this.formData.sortNum = data;
      }
    }
  },
  mounted() {
    this.getTempGroupOptions();
    this.type == 'edit' && this.getDetail();
    this.type == 'create' && this.getSortNum();
  }
};
</script>
<style lan="less" scoped>
.formBox {
  width: 50%;
  margin: 30px auto;
}
</style>
